<template>
  <div>
    보고서 양식이 없습니다.
  </div>
</template>

<script>
export default {
  name: 'TemplateNone'
}
</script>

<style scoped>

</style>
